

enum SubmitState {
    None,
    Submitted,
    Error,
}

export { SubmitState };